import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
export const Gates = {
  VIDEO_MANAGEMENT_PICKER_EMBED: gate('MediaContent:Video:VideoManagementEmbed')
};
export const isUngated = gateName => {
  try {
    const auth = userInfoSync();
    return auth.gates.includes(gateName);
  } catch (e) {
    return false;
  }
};